import { randomInRange } from '~/bootcamp/Activities/utils/activities.utils'

/**
 * It generates a random numerator and denominator, and then validates the numerator and denominator against the
 * history
 * @param {number} minNumerator - The minimum value for the numerator.
 * @param {number} maxNumerator - The maximum value of the numerator.
 * @param {number} minDenominator - The minimum value for the denominator.
 * @param {number} maxDenominator - The maximum denominator that can be generated.
 * @param {number[]} history - an array of numbers that have already been used in the current activity.
 * @returns { numerator: number; denominator: number }
 */
export function generateDenominatorNumerator(
  minNumerator: number,
  maxNumerator: number,
  minDenominator: number,
  maxDenominator: number,
  history: Array<{ numerator: number; denominator: number }>,
): { numerator: number; denominator: number } {
  const numerator = randomInRange(minNumerator, maxNumerator)
  const denominator = randomInRange(Math.max(numerator + 1, minDenominator), maxDenominator)

  const taskExists = history.some((task) => task.numerator === numerator && task.denominator === denominator)
  if (taskExists) {
    return generateDenominatorNumerator(minNumerator, maxNumerator, minDenominator, maxDenominator, history)
  }

  return { numerator, denominator }
}
